import {
  App,
  Col,
  List, Modal,
  Row,
  Typography
} from 'antd';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAdditionalLinks, getDefinedContent } from "../../api/driver";
import { showApiError } from "../../utility/error/error-handler";
import { getRandomInt } from "../../utility/global-util";
import { asAPIUrl } from "../../utility/fetch-util";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";
import { useScreenSizeBelow } from "../../utility/hooks/useScreenSize";
import PanelFrameWithImage from "./PanelFrameWithImage";
import OurHTMLFormattedText from "../data/OurHTMLFormattedText";

const { Link} = Typography;

const AdditionalLinksPanel = ({vehicle, backgroundType, refreshPage, setRefreshPage}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [links, setLinks] = useState(null);
  const [contents, setContents] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);

  const { t } = useTranslation();
  const { isOnline } = useOnlineStatus();
  const { notification } = App.useApp();

  useEffect(() => {
      getAdditionalLinks()
      .then(res => {
          setLinks(res);
          if(isOnline)
          {
             res.map(link => {
               if(link.type === 'CONTENT')
               {
                  getDefinedContent(link.contentSetId).then((content)=>{console.log(content)});
               }
               return '';
             })
          }
        }, )
      .catch(err => {
          showApiError(t('title.driver_information'), err, notification);
        });
    setRefreshPage(false);
  }, [t, notification, vehicle, refreshPage, setRefreshPage, isOnline]);

  const ViewPanel = () => {
    let displayHeight=188;
    if (useScreenSizeBelow(992)) {
      displayHeight = null;
    }

    function showContent(title, contentSetId)
    {
        setSelectedLink(title);
        getDefinedContent(contentSetId)
        .then(res => {
          setIsModalVisible(true);
          setContents(res);}, )
        .catch(err => {
          showApiError(t('title.driver_information'), err, notification);
        });
    }

    return (
      <div style={{height:displayHeight, overflow:'auto', width:'100%'}}>
      <List>
        {links.map(link => (
          <List.Item key={getRandomInt(1, 1000)} >
              <Row style={{width:'100%'}} align="middle" justify="center">
                <Col xs={3} sm={3} md={2} lg={2} xl={2}>
                  <img src={asAPIUrl(link.imageUrl?"/" + link.imageUrl:"/favicon.ico")} alt={link.title} style={{height:'14px'}}/>
                </Col>
                <Col xs={21} sm={21} md={22} lg={22} xl={22}>
                  {
                     (link.type === 'LINK')
                     ?
                     <Link href={link.url} target="_new">{link.title}</Link>
                     :
                     <Link onClick={() => showContent(link.title, link.contentSetId)}>{link.title}</Link>
                  }
                </Col>
              </Row>
          </List.Item>
        ))}
      </List>
      </div>
    )
  }
  
  if(links && links.length > 0)
  {
  return (
    <PanelFrameWithImage title={t('title.driver_information')}
                backgroundType={backgroundType} height="260px">
        <ViewPanel/>
        <Modal className="std-portal-popup"
                    open={isModalVisible}
                    title={selectedLink}
                    closable={true}
                    maskClosable={true}
                    keyboard={true}
                    footer={null}
                    onCancel={() => {setIsModalVisible(false)}}>
        <List>
          {contents.map(content => (
            <List.Item key={getRandomInt(1, 1000)} >
              <OurHTMLFormattedText htmlFormattedText={content} />
            </List.Item>
          ))}
          </List>
        </Modal>
    </PanelFrameWithImage>
  );
  }
  else
  {
     return <></>;
  }
}

export default AdditionalLinksPanel;